module.exports = __webpack_public_path__ + "static/avatar-68ec81c949b9dacc99e907de721ff69f.jpg";